import {
  MDBBtn,
  MDBBtnGroup,
  MDBCheckbox,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBTimepicker,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import remove from "../components/images/remove.svg";

export default function CRPlans(props) {
  const { t, i18n } = useTranslation();

  const [activPlan, setActivPlan] = useState(props.activePlan);
  const [routePlanOrder, setRoutPlanOrder] = useState([]);

  useEffect(() => {
    if (props.activePlan !== undefined) {
      setActivPlan(props.activePlan);
      let orderedActivePlan = props.routingPlans.filter((items)=>items.dial_planid === props.activePlan);
      let otherOrderedPlans = props.routingPlans.filter((items)=>items.dial_planid !== props.activePlan);
      setRoutPlanOrder([...orderedActivePlan, ...otherOrderedPlans]);
      console.log("ewfnwe "+JSON.stringify([...orderedActivePlan, ...otherOrderedPlans]))
      }
  }, [props.activePlan, props.routingPlans]);


  return (
    <>
      <select style={{ width: "210px" }}
        className="form-control form-select"
        name="Routing Plans"
        value={activPlan}
        onChange={(e) => {
          e.preventDefault();
          if (parseInt(e.target.value) !== -1) {
            setActivPlan(parseInt(e.target.value));
            props.updatePlanValue(
              parseInt(e.target.value),
              parseInt(props.dayIndex) == 0 ? "twentyFourPlan" : "weekly",
              parseInt(props.dayIndex)
            );
          } else {
            props.createPlan();

          }
        }}
      >
        {props.isCreatePlan && (
          <option key={-1} value={-1}> Create Routing Plan </option>
        )}
        {props.routingPlans && routePlanOrder &&
          routePlanOrder.map((items) => (
            <>
              <option key={items.dial_planid} value={items.dial_planid}>
                {items.name}
              </option>
            </>
        ))}

      </select>
    </>
  );
}
